import React from 'react';
import {View} from 'react-native';
import makeStyles from './styles.web';
import {FILTER_TYPE} from '../../utils/Constants';
import {useTheme, useThemedStyles} from '../../theme';
import CommonStyles from '../../utils/CommonStyles';
import Text from '../../components/elements/Text';
import {tID} from '../../utils/TestIdHelper';
import {FilterSearchBar} from '.';

const UI = ({
  children,
  searchTerm,
  selectedFilters,
  setSelectedFilters,
  setSearchTerm,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <View testID={tID('Shopping-View-Main')} style={styles.mainView}>
      <View
        testID={tID('Shopping-View-TitleContainer')}
        style={styles.titleContainer}>
        <Text
          testID={tID('Shopping-Text-Title')}
          variation="Headline5SemiBold"
          color={colors.textPrimary}
          style={CommonStyles.full_flex}>
          Products & Supplies
        </Text>
        <FilterSearchBar
          placeholder="Search product..."
          searchTerm={searchTerm}
          selectedFilters={selectedFilters}
          type={FILTER_TYPE.product}
          setSelectedFilters={setSelectedFilters}
          setSearchTerm={setSearchTerm}
        />
      </View>
      {children}
    </View>
  );
};

export default UI;
